import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-547bf406"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header header-elements-inline" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Ausnahme(n)", -1))
const _hoisted_3 = { class: "header d-flex flex-row" }
const _hoisted_4 = { class: "btn-group d-md-none" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-sm",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-more2" })
], -1))
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item",
  onclick: "$('#modalEditException').modal('show')"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-plus3" }),
  /*#__PURE__*/_createTextVNode(" Ausnahme hinzufügen")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" in andere Anlagen kopieren")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Alle löschen")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "btn_modalEditSystemTime",
  type: "button",
  class: "d-none d-md-block btn btn-accent btn-sm mr-1 mr-lg-2 d-flex flex-row flex-nowrap",
  onclick: "$('#modalEditException').modal('show')"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-plus3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Ausnahme hinzufügen")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Ausgewählte Ausnahme(n) in andere Anlagen kopieren", -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Alle löschen", -1))
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "alert bg-light d-flex justify-content-between align-items-center"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sie haben noch nicht gesicherte Daten. Bitte drücken Sie auf 'Ausnahme speichern'.", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-floppy-disk" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Jetzt speichern")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  class: "media-list media-list-linked media-list-bordered",
  id: "system_timeRows"
}
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = ["id", "name", "value"]
const _hoisted_32 = { class: "btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3 border-blue text-blue" }
const _hoisted_33 = {
  key: 0,
  class: "fa-solid fa-door-open text-blue"
}
const _hoisted_34 = {
  key: 1,
  class: "fa-solid fa-door-closed text-blue"
}
const _hoisted_35 = { class: "media-body align-self-center" }
const _hoisted_36 = { class: "font-weight-bold" }
const _hoisted_37 = { class: "text-muted ml-3" }
const _hoisted_38 = {
  key: 0,
  class: "badge bg-slate"
}
const _hoisted_39 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_40 = { class: "btn-group d-md-none" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-sm",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-more2" })
], -1))
const _hoisted_42 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-pen6" }, null, -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Bearbeiten")
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1))
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Löschen")
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "media-right align-self-center mr-1 d-none d-md-block" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-pen6" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "media-right align-self-center d-none d-md-block" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  class: "modal fade",
  id: "modalEditException",
  role: "dialog"
}
const _hoisted_60 = { class: "modal-dialog modal-md" }
const _hoisted_61 = { class: "modal-content" }
const _hoisted_62 = { class: "modal-header" }
const _hoisted_63 = { class: "modal-title" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal"
}, "×", -1))
const _hoisted_65 = { class: "modal-body" }
const _hoisted_66 = { id: "ausnahme-form" }
const _hoisted_67 = { class: "form-group row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-lg-2" }, "Typ", -1))
const _hoisted_69 = { class: "col-lg-10" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Bitte wählen", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Scharf" }, "Anlage scharf", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Unscharf" }, "Anlage unscharf", -1))
const _hoisted_73 = [
  _hoisted_70,
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = { class: "form-group row" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-lg-2",
  for: "exceptionDate"
}, "Datum", -1))
const _hoisted_76 = { class: "col-lg-10" }
const _hoisted_77 = { class: "form-group row" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-lg-2",
  for: "exceptionTime"
}, "Time", -1))
const _hoisted_79 = { class: "col-lg-10" }
const _hoisted_80 = { class: "form-group row" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-lg-2" }, "Kommentar", -1))
const _hoisted_82 = { class: "col-lg-10" }
const _hoisted_83 = { class: "modal-footer" }
const _hoisted_84 = {
  class: "modal fade",
  id: "modalCopySystemExceptionsToSystems",
  role: "dialog"
}
const _hoisted_85 = { class: "modal-dialog modal-md" }
const _hoisted_86 = { class: "modal-content" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Ausgewählte Ausnahmen in andere Anlagen kopieren"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal"
  }, "×")
], -1))
const _hoisted_88 = { class: "modal-body" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "alert alert-danger" }, [
  /*#__PURE__*/_createTextVNode("Die Zeiten werden direkt im Alarmplan und in der Anlage geändert. Haben Sie die Zeiten für "),
  /*#__PURE__*/_createElementVNode("u", null, [
    /*#__PURE__*/_createElementVNode("b", null, "alle")
  ]),
  /*#__PURE__*/_createTextVNode(" korrekt eingetragen? Bitte vermeiden Sie mehrfache Änderungen an einem Tag!"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_90 = { id: "frm_systemExceptionsCopyToSystems" }
const _hoisted_91 = {
  key: 0,
  class: "custom-control custom-switch custom-control-dark mb-2"
}
const _hoisted_92 = ["id", "name", "value", "disabled"]
const _hoisted_93 = ["for"]
const _hoisted_94 = { class: "text-muted" }
const _hoisted_95 = { class: "modal-footer d-flex flex-row justify-content-end align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("a", {
              href: "#",
              class: "dropdown-item",
              disabled: false,
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showCopyExceptionTimesToModal && _ctx.showCopyExceptionTimesToModal(...args)), ["prevent"]))
            }, _hoisted_10),
            _createElementVNode("a", {
              href: "#",
              class: "dropdown-item",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteAllTimes && _ctx.deleteAllTimes(...args)), ["prevent"]))
            }, _hoisted_13),
            _hoisted_14
          ])
        ]),
        _hoisted_15,
        _createElementVNode("button", {
          id: "btn_copySystemTimes",
          type: "button",
          class: "d-none d-md-block btn btn-accent btn-sm mr-1 mr-lg-2",
          disabled: false,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showCopyExceptionTimesToModal && _ctx.showCopyExceptionTimesToModal(...args)))
        }, _hoisted_19),
        _createElementVNode("button", {
          id: "btn_deleteSystemTimes",
          type: "button",
          class: "d-none d-md-block btn btn-danger btn-sm mr-1 mr-lg-2",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteAllTimes && _ctx.deleteAllTimes(...args)))
        }, _hoisted_23)
      ])
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.unsavedChanges)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveAllSystemExceptions && _ctx.saveAllSystemExceptions(...args)))
              }, _hoisted_28)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("ul", _hoisted_29, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchingExceptionTimes, (switchingExceptionTime, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "media"
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", null, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "",
                id: 'system' + switchingExceptionTime.id,
                name: 'system' + switchingExceptionTime.id,
                value: switchingExceptionTime.id,
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectException($event)))
              }, null, 40, _hoisted_31)
            ]),
            _createElementVNode("a", _hoisted_32, [
              (switchingExceptionTime.event == '100')
                ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                : _createCommentVNode("", true),
              (switchingExceptionTime.event == '200')
                ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createTextVNode(_toDisplayString(switchingExceptionTime.armingTime) + " ", 1),
              _createElementVNode("span", _hoisted_37, " ( " + _toDisplayString(switchingExceptionTime.comment) + " ) ", 1)
            ]),
            (switchingExceptionTime.event == '100')
              ? (_openBlock(), _createElementBlock("span", _hoisted_38, " Unscharf "))
              : _createCommentVNode("", true),
            (switchingExceptionTime.event == '200')
              ? (_openBlock(), _createElementBlock("span", _hoisted_39, " Scharf "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("a", {
                href: "#",
                class: "dropdown-item",
                onClick: ($event: any) => (_ctx.editSwitchingException(switchingExceptionTime.id))
              }, _hoisted_46, 8, _hoisted_43),
              _createElementVNode("a", {
                href: "#",
                class: "dropdown-item",
                onClick: ($event: any) => (_ctx.deleteSwitchingException(switchingExceptionTime))
              }, _hoisted_50, 8, _hoisted_47)
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("button", {
              class: "btn bg-primary btn-sm",
              onClick: ($event: any) => (_ctx.editSwitchingException(switchingExceptionTime.id))
            }, _hoisted_54, 8, _hoisted_52)
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("button", {
              class: "btn bg-danger btn-sm",
              onClick: ($event: any) => (_ctx.deleteSwitchingException(switchingExceptionTime))
            }, _hoisted_58, 8, _hoisted_56)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("h4", _hoisted_63, "Ausnahme: " + _toDisplayString(_ctx.exceptionStatus), 1),
            _hoisted_64
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("form", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("div", _hoisted_69, [
                  _withDirectives(_createElementVNode("select", {
                    id: "typSelection",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.switchingExceptionTime.typ) = $event)),
                    class: "form-control",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateExceptionTyp($event.target.value)))
                  }, _hoisted_73, 544), [
                    [_vModelSelect, _ctx.switchingExceptionTime.typ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.switchingExceptionTime.switchingDate) = $event)),
                    class: "chrome-datepicker w-100",
                    type: "date",
                    id: "exceptionDate",
                    name: "exceptionDate"
                  }, null, 512), [
                    [_vModelText, _ctx.switchingExceptionTime.switchingDate]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.switchingExceptionTime.switchingTime) = $event)),
                    class: "chrome-datepicker w-100",
                    type: "time",
                    step: "900",
                    id: "exceptionTime",
                    name: "exceptionTime"
                  }, null, 512), [
                    [_vModelText, _ctx.switchingExceptionTime.switchingTime]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _createElementVNode("div", _hoisted_82, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.switchingExceptionTime.kommentar) = $event)),
                    class: "form-control w-100",
                    type: "text",
                    placeholder: "Kommentare eingeben"
                  }, null, 512), [
                    [_vModelText, _ctx.switchingExceptionTime.kommentar]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.saveSystemExceptionTime && _ctx.saveSystemExceptionTime(...args)))
            }, "Speichern")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_84, [
      _createElementVNode("div", _hoisted_85, [
        _createElementVNode("div", _hoisted_86, [
          _hoisted_87,
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _createElementVNode("form", _hoisted_90, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systems, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "form-group"
                }, [
                  (item.anlage_id !== _ctx.systemId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: 'exception' + index,
                          name: 'exception' + item.anlage_id,
                          value: item.anlage_id,
                          disabled: !item.enabled
                        }, null, 8, _hoisted_92),
                        _createElementVNode("label", {
                          class: "custom-control-label",
                          for: 'exception' + index
                        }, [
                          _createTextVNode(_toDisplayString(item.anlage_nummer) + " ", 1),
                          _createElementVNode("span", _hoisted_94, _toDisplayString(item.anlage_bemerkung), 1)
                        ], 8, _hoisted_93)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.copyExceptionsToSystems && _ctx.copyExceptionsToSystems(...args)))
            }, "Zeiten kopieren")
          ])
        ])
      ])
    ])
  ], 64))
}